import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=c5ed5f7a&"
import script from "./Integrations.vue?vue&type=script&lang=js&"
export * from "./Integrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5ed5f7a')) {
      api.createRecord('c5ed5f7a', component.options)
    } else {
      api.reload('c5ed5f7a', component.options)
    }
    module.hot.accept("./Integrations.vue?vue&type=template&id=c5ed5f7a&", function () {
      api.rerender('c5ed5f7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Integrations.vue"
export default component.exports